import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customPath": "/models/octavia",
  "description": "SKODA OCTAVIA. В 4-ом поколении Шкода Октавия 2023 (А8) сохранила привычный кузов лифтбек, сочетающий элегантность и невероятную практичность. Обзор. Комплектации. Запись на тест-драйв на официальном сайте ŠKODA в России.",
  "huggerTemplate": "default",
  "keywords": "octavia",
  "name": "octavia",
  "title": "Купить SKODA OCTAVIA 2023/2022 – лифтбек Шкода Октавия A8 на официальном сайте ŠKODA",
  "schemaOrg": "Product"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const QueriedShowroomMainStage = makeShortcode("QueriedShowroomMainStage");
const SaleEvent = makeShortcode("SaleEvent");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const SimpleTeaser = makeShortcode("SimpleTeaser");
const CustomIFrame = makeShortcode("CustomIFrame");
const SimpleTeaserSubTitle = makeShortcode("SimpleTeaserSubTitle");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const DefSectionBtnContainer = makeShortcode("DefSectionBtnContainer");
const Button = makeShortcode("Button");
const Heading = makeShortcode("Heading");
const FeaturesSliderQueried = makeShortcode("FeaturesSliderQueried");
const QueriedGallery = makeShortcode("QueriedGallery");
const AvnWidget = makeShortcode("AvnWidget");
const PaddedTilesContainer = makeShortcode("PaddedTilesContainer");
const PaddedTilesTile = makeShortcode("PaddedTilesTile");
const Slider = makeShortcode("Slider");
const SlideIcon = makeShortcode("SlideIcon");
const QueriedDlNew = makeShortcode("QueriedDlNew");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <QueriedShowroomMainStage tags="octavia2020-main" withSchemaOrg mdxType="QueriedShowroomMainStage" />
    <SaleEvent tags="saleevent-octavia-1" mdxType="SaleEvent" />
    <SaleEvent tags="saleevent-octavia-2" mdxType="SaleEvent" />
    <SaleEvent tags="saleevent-octavia-3" mdxType="SaleEvent" />
    <DefaultPaddedSection bgColor="#FFF" fullWidth mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">ЦЕННО НАСТОЯЩЕЕ</DefaultSectionHeading>
  <SimpleTeaser bgColor="#F2F2F2" aspect="16/9" renderVisual={<CustomIFrame title="tube" width="100%" height="100%" src="https://www.youtube.com/embed/ROC8n29pFRI?rel=0" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen mdxType="CustomIFrame" />} mdxType="SimpleTeaser">
    <SimpleTeaserSubTitle mdxType="SimpleTeaserSubTitle">
      ŠKODA OCTAVIA раскрывает настоящие ценности бренда ŠKODA.
    </SimpleTeaserSubTitle>
    <DefaultSectionText align="left" fullWidth mdxType="DefaultSectionText">
      <p>
        Каждая деталь OCTAVIA создана с искренней заботой и особым вниманием к
        водителю и каждому пассажиру.
      </p>
      <p>
        Современный дизайн матричных фар мгновенно привлекает внимание.
        Виртуальная приборная панель и десятидюймовый мультимедийный дисплей
        впечатляют не только эргономичностью, но и эстетичностью. А превосходная
        динамика и отличная управляемость обеспечивают настоящее удовольствие от
        вождения.
      </p>
      <p>ŠKODA OCTAVIA. Ценно настоящее.</p>
    </DefaultSectionText>
  </SimpleTeaser>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionText mdxType="DefaultSectionText">
    ŠKODA OCTAVIA — самая популярная модель за всю 125‑летнюю историю чешской
    компании. Абсолютный бестселлер марки. С 1959 года было продано более 7 млн
    машин, название которых знакомо покупателям в 100 с лишним странах мира.
    Менялись поколения автомобиля, но неизменным оставалось главное: OCTAVIA
    всегда давала клиентам больше, чем они могли ожидать.
  </DefaultSectionText>
  <DefSectionBtnContainer mdxType="DefSectionBtnContainer">
    <Button glyph="download" href="/m/catalogs/octavia-catalogue.pdf" mdxType="Button">
      Скачать каталог
    </Button>
    <Button href="https://cc.skoda-avto.ru/models/octavia" mdxType="Button">Конфигуратор</Button>
  </DefSectionBtnContainer>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionText mdxType="DefaultSectionText">
    <p>
      Мы сделали все, чтобы Ваша по-настоящему ценная встреча со{" "}
      <b>ŠKODA OCTAVIA</b> стала незабываемым событием.
    </p>
    <p>
      <b>Ждем Вас и Ваших близких во всех салонах официальных дилеров ŠKODA.</b>
    </p>
  </DefaultSectionText>
  <DefSectionBtnContainer mdxType="DefSectionBtnContainer">
    <Button type="primary" href="/test-drive" mdxType="Button">
      Записаться на тест-драйв
    </Button>
  </DefSectionBtnContainer>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#767676" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    <Heading size="h3" color="white" bold center mdxType="Heading">
      Видеопрезентация ŠKODA OCTAVIA
    </Heading>
  </DefaultSectionHeading>
  <DefSectionBtnContainer mdxType="DefSectionBtnContainer">
    <Button href="/models/octavia/video" mdxType="Button">Смотреть</Button>
  </DefSectionBtnContainer>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Особенности</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    OCTAVIA уже заняла в Европе привычное для себя место — одного из лидеров
    рынка. Нет сомнений, что модель понравится и нашим российским покупателям.
    Мы знаем, что нужно клиентам самой большой страны в мире. Не зря автомобили
    чешской марки продаются в России с самого начала XX века.
  </DefaultSectionText>
  <FeaturesSliderQueried tags="octavia2020-over" filterTags={[{
        name: "Дизайн",
        tag: "design"
      }, {
        name: "Мультимедиа",
        tag: "multimedia"
      }, {
        name: "Безопасность",
        tag: "safety"
      }, {
        name: "Комфорт",
        tag: "comfort"
      }]} mdxType="FeaturesSliderQueried" />
    </DefaultPaddedSection>
    <QueriedGallery presetName="4" type="modal" tags="octavia-2020-overviewpage" filterTags={[{
      name: "интерьер",
      tag: "interior"
    }, {
      name: "экстерьер",
      tag: "exterior"
    }]} mdxType="QueriedGallery" />
    <div id="test-drive"></div>
    <DefaultPaddedSection noPs bgColor="#FFF" mdxType="DefaultPaddedSection">
  <AvnWidget tags="avnwidget-octavia" mdxType="AvnWidget" />
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" tag="Octavia" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">ОБЗОР 360° ŠKODA OCTAVIA</DefaultSectionHeading>
  <CustomIFrame key="Octavia" lazy adaptive height="700px" src="https://virtual-test-drive.skoda-avto.ru/octavia" previewSrc="/m/octavia-vtd-new.jpg" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen mdxType="CustomIFrame" />
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    Оригинальные детали и аксессуары ŠKODA
  </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Вы всегда можете подобрать необходимые оригинальные детали или аксессуары
    для Вашего автомобиля ŠKODA, воспользовавшись нашим онлайн-магазином.
  </DefaultSectionText>
  <PaddedTilesContainer mdxType="PaddedTilesContainer">
    <PaddedTilesTile imgSrc="/m/all_pages_parts.png" title="оригинальные аксессуары ŠKODA" href="https://parts.skoda-avto.ru/accessories" linkText="Перейти в каталог" mdxType="PaddedTilesTile" />
    <PaddedTilesTile imgSrc="/m/all_pages_acc.png" title="Оригинальные детали ŠKODA" href="https://parts.skoda-avto.ru/" linkText="Перейти в каталог" mdxType="PaddedTilesTile" />
  </PaddedTilesContainer>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" noPt mdxType="DefaultPaddedSection">
  <Slider slidesToShow={1} mdxType="Slider">
    <SlideIcon key="/m/subscribe.svg" icon="/m/subscribe.svg" title="Подписаться" text=" Подпишитесь на новости о ŠKODA" buttonText="Подписаться на новости" buttonLink="/subscribe" mdxType="SlideIcon" />
  </Slider>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Где купить</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Дилерские центры ŠKODA расположены таким образом, чтобы Вы могли в любой
    момент обратиться в любой из них по интересующему Вас вопросу, будь то
    запись на плановое ТО, покупка нового автомобиля или сдача старого в
    trade-in. Здесь Вы найдете всю необходимую информацию для связи с дилером.
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedDlNew mdxType="QueriedDlNew" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      